import { render } from "./Products.vue?vue&type=template&id=1235f052"
import script from "./Products.vue?vue&type=script&lang=js"
export * from "./Products.vue?vue&type=script&lang=js"

import "./Products.vue?vue&type=style&index=0&id=1235f052&lang=css"
script.render = render

export default script